import React from "react";

export const VuesaxBulkKey1 = ({ className }) => {
  return (
    <svg
      className={`vuesax-bulk-key-1 ${className}`}
      fill="none"
      height="18"
      viewBox="0 0 18 18"
      width="18"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="path"
        d="M14.8425 3.16499C12.6225 0.95249 9.02249 0.95249 6.81749 3.16499C5.26499 4.70249 4.79999 6.91499 5.39999 8.86499L1.87499 12.39C1.62749 12.645 1.45499 13.1475 1.50749 13.5075L1.73249 15.1425C1.81499 15.6825 2.31749 16.1925 2.85749 16.2675L4.49249 16.4925C4.85249 16.545 5.35499 16.38 5.60999 16.1175L6.22499 15.5025C6.37499 15.36 6.37499 15.12 6.22499 14.97L4.76999 13.515C4.55249 13.2975 4.55249 12.9375 4.76999 12.72C4.98749 12.5025 5.34749 12.5025 5.56499 12.72L7.02749 14.1825C7.16999 14.325 7.40999 14.325 7.55249 14.1825L9.14249 12.6C11.085 13.2075 13.2975 12.735 14.8425 11.1975C17.055 8.98499 17.055 5.37749 14.8425 3.16499ZM10.875 8.99999C9.83999 8.99999 8.99999 8.15999 8.99999 7.12499C8.99999 6.08999 9.83999 5.24999 10.875 5.24999C11.91 5.24999 12.75 6.08999 12.75 7.12499C12.75 8.15999 11.91 8.99999 10.875 8.99999Z"
        fill="url(#paint0_linear_12_4967)"
        opacity="0.4"
      />

      <path
        className="path"
        d="M10.875 9C11.9105 9 12.75 8.16053 12.75 7.125C12.75 6.08947 11.9105 5.25 10.875 5.25C9.83947 5.25 9 6.08947 9 7.125C9 8.16053 9.83947 9 10.875 9Z"
        fill="url(#paint1_linear_12_4967)"
      />

      <defs className="defs">
        <linearGradient
          className="linear-gradient"
          gradientUnits="userSpaceOnUse"
          id="paint0_linear_12_4967"
          x1="1.49805"
          x2="16.5019"
          y1="9.00392"
          y2="9.00392"
        >
          <stop className="stop" stopColor="#FF6EB3" />

          <stop className="stop" offset="0.471154" stopColor="#AA81FF" />

          <stop className="stop" offset="1" stopColor="#6BC9FF" />
        </linearGradient>

        <linearGradient
          className="linear-gradient"
          gradientUnits="userSpaceOnUse"
          id="paint1_linear_12_4967"
          x1="9"
          x2="12.75"
          y1="7.125"
          y2="7.125"
        >
          <stop className="stop" stopColor="#FF6EB3" />

          <stop className="stop" offset="0.471154" stopColor="#AA81FF" />

          <stop className="stop" offset="1" stopColor="#6BC9FF" />
        </linearGradient>
      </defs>
    </svg>
  );
};
